export default {
  name: 'marina',

  ui: {
    toggleFullscreen: '[js-marina-fullscreen]',
    iframe: '[js-marina-iframe]',
    'button[]': '[js-marina-button]',
  },

  events: [
    {
      on: 'click',
      target: 'toggleFullscreen',
      handle () {
        this.ui.iframe.classList.toggle('is-full')
        this.ui.button.forEach(button => {
          button.classList.toggle('is-full')
        })
      },
    },
  ],

  componentDidMount () {

  },
}
